import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AdminAuthGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this.authService.currentUserValue) {
      return true;
    }
    this.router.navigate(['/admin']);
    return false;
  }
}
